import { BehaviorSubject } from 'rxjs';
import { useState, useEffect } from 'react';
import * as applications from './applications';

// the currently active application: what's highlighted in the sidebar and
// where the user will be sent if they change clients.
export const currentApplication = new BehaviorSubject(
    applications[applications.defaultApplication],
);

// should a microfrontend need access to the current application they can use
// this hook.
export function useCurrentApplication() {
    const [app, setApp] = useState(currentApplication.getValue());

    useEffect(() => {
        const observer = currentApplication.subscribe(app => setApp(app));
        return () => observer.unsubscribe();
    }, [setApp]);

    return app;
}

/**
 * Allows changing the current application that's active in the content area
 * of Alli UI.
 *
 * This is mainly used for two things:
 *
 *      1. Control the application that's "active" and open in the sidebar
 *      2. Control the applicaiton that's active in the content area for
 *         monitoring purposes.
 *
 * Applications can also override the active subnave item here.
 */
export function setCurrentApplication(
    applicationId,
    { clientUrl, id, activeSubnavItem } = {},
) {
    const base =
        applications[applicationId] ||
        applications[applications.defaultApplication];

    const overrides = {};
    if (clientUrl) {
        overrides.clientUrl = clientUrl;
        overrides.isSpa = true;
    }

    if (typeof activeSubnavItem !== 'undefined') {
        overrides.activeSubnavItem = activeSubnavItem;
    }

    overrides.monitoringId = id || applicationId;

    currentApplication.next({ ...base, ...overrides });
}

/**
 * Like `setCurrentApplication`, but only allows changing overriden values as
 * a user navigates _within_ an application and needs to change the state
 * of the application as whole.
 */
export function updateCurrentApplication({ activeSubnavItem } = {}) {
    const overrides = {};
    if (typeof activeSubnavItem !== 'undefined') {
        overrides.activeSubnavItem = activeSubnavItem;
    }

    currentApplication.next({ ...currentApplication.getValue(), ...overrides });
}
